<template>
	<div id="root-side" :class="{ opened: rootSideOpened, 'side-opened': sideOpened }">
		<Globals />
		<h3>{{ $t('song.playlists') }}</h3>
		<Playlists />
		<h3>{{ $t('song.authors') }}</h3>
		<Authors />
		<br><br><br>
	</div>
</template>

<script>
	import Playlists from "./Playlists";
	import Authors from "./Authors";
	import Globals from "./Globals";
	import { mapState } from "vuex";

	export default {
		components: {
			Playlists, Authors, Globals
		},
		computed: {
			...mapState([ "sideOpened", "rootSideOpened" ])
		}
	}
</script>

<style lang="scss">
	#root-side {
		height: 0;
		width: 260px;
		position: fixed;
		z-index: 2;
		top: 50px;
		top: calc(constant(safe-area-inset-top) + 50px);
		top: calc(env(safe-area-inset-top) + 50px);
		left: -260px;
		overflow-x: hidden;
		background: rgb(233,196,106); /* Old browsers */
		background: -moz-linear-gradient(left, rgba(233,196,106,1) 1%, rgba(244,162,97,1) 100%); /* FF3.6-15 */
		background: -webkit-linear-gradient(left, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* Chrome10-25,Safari5.1-6 */
		background: linear-gradient(to right, rgba(233,196,106,1) 1%,rgba(244,162,97,1) 100%); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
		filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#e9c46a', endColorstr='#f4a261',GradientType=1 ); /* IE6-9 */
		-webkit-overflow-scrolling: touch;

		-webkit-transition: height 0.2s, left 0.2s;
		-moz-transition: height 0.2s, left 0.2s;
		-o-transition: height 0.2s, left 0.2s;
		transition: height 0.2s, left 0.2s;

		&.side-opened {
			left: 0;
		}

		&::-webkit-scrollbar {
			width: 8px;
		}

		&::-webkit-scrollbar-track {
			-webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
			background-color: rgba(59, 115, 135, 0.26);
		}

		&::-webkit-scrollbar-thumb {
			background-color: rgba(42, 157, 143, 0.7);
		}

		&.opened {
			height: 100%;
		}

		.icon-menu {
			padding: 9px 15px;
		}

		.tag {
			cursor: pointer;
			opacity: 0.6;
			background-color: rgba(255, 255, 255, 0.45);
			margin-bottom: 1px;
			line-height: 30px;
			padding: 7px 15px 7px 15px;
			color: rgb(0, 0, 0);
			font-weight: 300;

			span {
				display: inline-block;
				float: right;
				opacity: 0.5;
			}
		}

		.tag:hover {
			opacity: 1;
		}

		h3 {
			margin: 5px 0 10px 15px;
			padding: 0;
			color: rgba(0, 0, 0, 0.71);
			font-size: 1em;
		}
	}
</style>
